<template>
  <b-form-group
    label="Bölge"
    label-for="region"
  >
    <validation-provider
      #default="{ errors }"
      name="Bölge"
      rules="required"
    >
      <b-form-input
        id="region"
        v-model="itemData.region"
        placeholder="Bölge"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'RegionText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
